<template>
    <div class="promo-Links">
        <div class="page-container">
            <div class="row no-gutters">
                <div class="col-12 col-md-4 px-4 mb-5 mb-md-0">
                    <a href="#">
                        <div class="circle-container bg-orange">
                            <div class="data py-4 px-5 txt-white text-center">
                                <h1 class="heading__h1 mb-4">Find</h1>
                                <p class="fs-2 lh-base">Browse offers from the places you love to shop.</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-md-4 px-4 mb-5 mb-md-0">
                    <a href="#">
                        <div class="circle-container bg-pink">
                            <div class="data py-4 px-5 txt-white text-center">
                                <h1 class="heading__h1 mb-4">Select</h1>
                                <p class="fs-2 lh-base">Choose the offers you’re interested in.</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-md-4 px-4 mb-5 mb-md-0">
                    <a href="#">
                        <div class="circle-container bg-orange">
                            <div class="data py-4 px-5 txt-white text-center">
                                <h1 class="heading__h1 mb-4">Earn</h1>
                                <p class="fs-2 lh-base">Get rewarded for treating yourself.</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PromoLinksComponent",
    }
</script>
